exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "cite{color:var(--ds-color-london-5);display:flex;font-family:var(--ds-type-system-sans);font-size:var(--ds-type-scale-3);font-style:normal;font-weight:700;line-height:var(--ds-type-leading-upper);margin:0}", ""]);

// exports
